import { render, staticRenderFns } from "./TotalList.vue?vue&type=template&id=5da7ae7a&scoped=true"
import script from "./TotalList.vue?vue&type=script&lang=js"
export * from "./TotalList.vue?vue&type=script&lang=js"
import style0 from "./TotalList.vue?vue&type=style&index=0&id=5da7ae7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da7ae7a",
  null
  
)

export default component.exports